/* Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons
Suresh Peddavoora 10/31/2022 3075154998  Changed class name for Text Fields
Lalitha  11/9/2022  3075154998 Rename Button Clear to Reset
Prakash Gummala 11/10/2022 3075154998 Text Field Alignments for Tab Resolution
*/
import React, {useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import FilterSearchTable from './DmrecordsSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useSelector} from 'react-redux';

const DmrecordSearch = ({
  setTabValue,
//   setFilterCode,
//   setFilterCodeName,
//   setIsCopyRowData,
//   setUsageState,
//   setFieldRowData,
//   fieldRowData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const {isLoading} = useSelector(
    ({filter}) => filter,
  );
  // const schema = Yup.object().shape({
  //   name: Yup.string().matches(
  //     /^[a-zA-Z0-9]+$/,
  //     "White space and special character are not allowed"
  //   ),
  // });

  const initialValues = {
    code: '',
    description: '',
  };
  const onClear = () => {
    const data = {
      code: '',
      description: '',
    };
    setSearchData(data);
  };

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  return (
    <>
      <div className={`mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          // validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, handleBlur, handleReset} = props;
            return (
              <div className="standard-field-textfields">
                <Form autoComplete="off" noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={3} md={3} sm={6} xl={3} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        placeholder={`Enter Code`}
                        label="Record Code"
                        name="code"
                        value={values?.code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={3} md={6} sm={6} xl={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        name="description"
                        placeholder={`Enter Description`}
                        label="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={3} md={3} sm={6} xl={4} className="form-group">
                      <div >
                        <Button
                          variant="outlined"
                          className={`reset-btn mx-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            handleReset();
                            setSearchData({});
                            setSubmit(true);
                            onClear();
                          }}
                        >
                    Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                    Search
                        </Button>
                      </div>
                    </Grid>
                  </Grid>

                </Form>
              </div>
            );
          }}
        </Formik>
        <Grid>
          <FilterSearchTable
            searchData={searchData}
            setTabValue={setTabValue}
            submit={submit}
            setSubmit={setSubmit}
            isLoading={isLoading}
            isDelete={isDelete}
            setIsDelete={setIsDelete}
          />
        </Grid>
      </div>
      {/* {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />} */}
    </>
  );
};
export default DmrecordSearch;
